export function encodeCategoryName(name) {
    return name.replace('/', `¿`);
}

export function decodeCategoryName(name) {
    return  name.replace(`¿`, '/')
}